/**
 * Calculates the total calories based on provided ingredients.
 */
export function calculateTotalCalories(ingredients: Ingredients): number | null {
  const hasOnlyInvalidValues = ingredients.every(checkIfHasInvalidValues);

  if (hasOnlyInvalidValues) {
    return null;
  }

  const totalCalories = [...ingredients].reduce(addCalories, 0);

  return Math.round(totalCalories);
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfHasInvalidValues(ingredient: Ingredient) {
  return typeof ingredient.calories !== 'number';
}

function addCalories(total: number, ingredient: Ingredient) {
  const calories = typeof ingredient.calories === 'number' ? ingredient.calories : 0; // prettier-ignore
  const quantity = ingredient.quantity ?? 1;

  return total + calories * quantity;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Ingredient = { calories: number | null; quantity?: number };
type Ingredients = Ingredient[] | readonly Ingredient[];
